import { BUSCAR_VEICULO } from '../../actions/types'

const initialState = undefined

const stateInicial = {
    descricao: '',
    tipoVeiculo: { chave: '', valor: ''}
};

export default function reducerBuscarVeiculos(state = stateInicial, action = initialState) {
  switch (action.type) {
        case BUSCAR_VEICULO: {
            const veiculo = action.payload.data;

            if (veiculo) {
                return veiculo
            }

            return stateInicial;
        }

        default: {
            return state
        }
        
    }
}